import {useMemo} from 'react';

// Detects iOS devices (iPhone, iPad, iPod) including iPadOS 13+ which reports
// as Macintosh but exposes touch. Used to hide in-app payment entry points so
// the PWABuilder-wrapped App Store build complies with Apple's policies on
// external purchases.
export function useIsIOS(): boolean {
  return useMemo(() => isIOS(), []);
}

export function isIOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  // iPadOS 13+ masquerades as Mac; detect via touch points.
  return (
    navigator.platform === 'MacIntel' &&
    typeof navigator.maxTouchPoints === 'number' &&
    navigator.maxTouchPoints > 1
  );
}
